const API_BASE = process.env.VUE_APP_API_BASE_URL || '';

export const floating_chat_send_methods = {
  prepare_message_send() {
    const backup = {
      draft: this.draft,
      reply_to: this.reply_to,
      file: this.selected_file,
      had_file: Boolean(this.selected_file),
    };
    this.draft = '';
    this.reply_to = null;
    this.selected_file = null;
    this.revoke_preview_url();
    return backup;
  },

  restore_message_send(backup) {
    this.draft = backup.draft;
    this.reply_to = backup.reply_to;
    this.selected_file = backup.file;
  },

  async post_message_form(content, backup) {
    const form_data = new FormData();
    form_data.append('conversation_id', this.active_conversation_id);
    form_data.append('content', content);
    if (backup.file) form_data.append('attachment', backup.file);
    if (backup.reply_to?.id) form_data.append('reply_to_id', backup.reply_to.id);

    const response = await fetch(`${API_BASE}/aic_one_api/one_chat_management/send_message/`, {
      method: 'POST',
      credentials: 'include',
      headers: this.auth_headers(null),
      body: form_data,
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok || body?.status !== 'success') throw new Error(body.message || 'Failed to send message');
    return body;
  },

  async apply_sent_message(message, had_file) {
    if (had_file) {
      await this.load_messages(this.active_conversation_id);
    } else {
      this.append_sent_message(message);
    }
    this.user_scrolled_up = false;
    this.new_messages_banner = false;
    this.scroll_to_bottom(true);
    this.load_conversations(true);
    window.dispatchEvent(new Event('refresh-unread-chats'));
  },

  append_sent_message(message) {
    this.messages.push(message);
    this.messages_offset += 1;
    if (!this.active_conversation) return;
    this.active_conversation.last_message = message;
    this.active_conversation.updated_at = message.created_at;
  },
};
